import React from 'react';
import { Layers } from 'lucide-react';
import MarkdownRenderer from '../common/MarkdownRenderer';

interface KeyFinding {
  primary_answer_breakdown: string;
  categorical_distribution: string;
}

interface KeyFindingsSummaryProps {
  finding: KeyFinding;
  totalRespondents?: number;
}

const KeyFindingsSummary: React.FC<KeyFindingsSummaryProps> = ({ finding }) => {
  if (!finding || !finding.categorical_distribution) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div className="bg-white border border-gray-200 rounded-lg p-5">
        <div className="flex items-start space-x-3">
          <Layers className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-blue-600 uppercase tracking-wide mb-2">
              Categorical Distribution
            </p>
            <div className="text-sm text-gray-700">
              <MarkdownRenderer content={finding.categorical_distribution} variant="compact" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyFindingsSummary;
